import React, {useEffect, useState} from "react";
import {
    BUTTON,
    MODAL_CANCEL_TEXT,
    MODAL_CLOSE_TEXT,
    MODAL_SAVE_TEXT,
    ROLES,
} from "../../utils/constants";
import FocusTrap from "../../components/FocusTrap";
import {Modal} from "react-bootstrap";
import YuJaButton from "../../components/standardization/YuJaButton";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import classes from "./InstitutionPage.module.css";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import EyeOpen from "../LoginPage/images/EyeOpen.svg";
import EyeClosed from "../LoginPage/images/EyeClosed.svg";
import {UserApiCalls} from "../../apis/UserApiCalls";

export default function CSMModal({setModalShow, show, user={}, reload}) {
    const {checkUserExist, saveUser} = UserApiCalls();
    const [isSaving, setIsSaving] = useState(false);
    const [rawUser, setRawUser] = useState({});
    const [tempUser, setTempUser] = useState({});
    const [pwdShown, setPwdShown] = useState(false);
    const [pwdConfirmShown, setPwdConfirmShown] = useState(false);
    const [errorState, setErrorState] = useState({});




    const handleClose = () =>{
        setModalShow(false);
    };

    const handleSave = async () => {
        let res = validate();
        if (!!res && !!Object.keys(res).length) {
            setErrorState(res);
            return;
        }

        setIsSaving(true);
        if (tempUser.userName !== rawUser.userName) {
            const exists = await checkUserExist({userName: tempUser.userName});
            if (exists) {
                const copy = JSON.parse(JSON.stringify(res));
                copy.userName = "User Name already exists.";
                setErrorState(copy);
                return;
           }
        }

        setErrorState(res);
        const isNewUser = !user || !Object.keys(user).length;
        saveUser(tempUser, isNewUser).then((success) => {
            if (success) {
                setModalShow(false);
                reload();
            }
        }).finally(() => setIsSaving(false));
        // shareUsageReport(yearMonth, email).then((success) => {
        //
        //     setModalShow(false);
        //     setEmail("");
        // }).finally(() => setIsSaving(false));
    };

    const isSaveBtnDisabled = () => {
        if (JSON.stringify(rawUser) === JSON.stringify(tempUser)) {
            return true;
        }

        const isNewUser = !user || !Object.keys(user).length;

        if (!tempUser.userName || !tempUser.userName.trim()
            || !tempUser.firstName || !tempUser.firstName.trim()
            || !tempUser.lastName || !tempUser.lastName.trim()
            || !tempUser.email || !tempUser.email.trim()
        ) {
            return true;
        }

        if (isNewUser && ( !tempUser.password || !tempUser.password.trim())) {
            return true;
        }


        if (!!errorState && !!Object.keys(errorState).length) {
            return true;
        }

        if (isSaving) {
            return true;
        }

        return false;
    }


    useEffect(() => {
        if (show) {
            if (!!user && !!Object.keys(user).length) {
                setRawUser(JSON.parse(JSON.stringify(user)));
                setTempUser(JSON.parse(JSON.stringify(user)));
            } else {
                setRawUser({role: ROLES.ADMINISTRATOR.value});
                setTempUser({role: ROLES.ADMINISTRATOR.value});
            }
            setErrorState({});
            setIsSaving(false);
            setPwdShown(false);
            setPwdConfirmShown(false);
        }

    }, [show]);

    const togglePwd = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await setPwdShown(!pwdShown);
        const input = document.getElementById('input-pwd');
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
    }

    const togglePwdConfirm = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await setPwdConfirmShown(!pwdConfirmShown);
        const input = document.getElementById('input-pwd-confirm');
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
    }

    const onBlur = (e) => {
        let name = e.target.name;
        let res = validate(name);
        if (name === "userName" && !res.userName && tempUser.userName !== rawUser.userName) {
            checkUserExist({userName: tempUser.userName}).then((exists) => {
                if (exists) {
                    const copy = JSON.parse(JSON.stringify(res));
                    copy.userName = "User Name already exists.";
                    setErrorState(copy);
                }
            });
        }

        setErrorState(res);
    }

    const validate = (name) => {
        const isNewUser = !user || !Object.keys(user).length;
        let copy = JSON.parse(JSON.stringify(errorState));
        if (!name || name === "userName") {
            const characterRegexp = /^\w+$/g;
            if (!tempUser.userName || !tempUser.userName.trim()) {
                copy.userName = "User Name is required.";
            } else if (!characterRegexp.test(tempUser.userName)) {
                copy.userName = "User Name can only contain letters, numbers, and '_'.";
            } else {
                delete copy.userName;
            }
        }

        if ((!name || name === "password") && isNewUser) {
            if (!tempUser.password || !tempUser.password.trim()) {
                copy.password = "Password is required.";
            } else {
                delete copy.password;
            }
        }

        if ((!name || name === "passwordConfirm") && isNewUser) {
            if (tempUser.password !== tempUser.passwordConfirm) {
                copy.passwordConfirm = "Please type the same password.";
            } else {
                delete copy.passwordConfirm;
            }
        }

        if (!name || name === "firstName") {
            if (!tempUser.firstName || !tempUser.firstName.trim()) {
                copy.firstName = "First Name is required.";
            } else {
                delete copy.firstName;
            }
        }

        if (!name || name === "lastName") {
            if (!tempUser.lastName || !tempUser.lastName.trim()) {
                copy.lastName = "Last Name is required.";
            } else {
                delete copy.lastName;
            }
        }

        if (!name || name === "email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!tempUser.email || !tempUser.email.trim()) {
                copy.email = "Email is required.";
            } else if (!emailRegex.test(tempUser.email)) {
                copy.email = "Please enter a valid email.";
            } else {
                delete copy.email;
            }
        }

        return copy;
    }



    return (
        <FocusTrap isOpened={show} setIsOpened={setModalShow}>
            <Modal
                id="CSM-user-modal"
                show={show}
                aria-labelledby="CSM-user-modal-title"
                backdrop={true}
                dialogClassName= {"save-question-bank-modal"}
            >

                <ModalClose
                    tabIndex={0}
                    role={BUTTON}
                    aria-label={MODAL_CLOSE_TEXT}
                    onClick={handleClose}
                    className="modal-close"
                    style={{width: "24px", height: "24px"}}
                />
                <Modal.Header
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Modal.Title as="h2" className="modal-title" id="CSM-user-modal-title">
                        {(!!user && !!Object.keys(user).length) ? "Edit CSM" : "Create CSM"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{display: "flex", flexDirection: "column", gap: 12, minHeight: 100, fontSize: 15}}>
                    <div className={classes.column} style={{gap: 2}}>
                        <span className={classes.label}>User Name</span>
                        <YuJaTextBox
                            name={"userName"}
                            containerStyle={{height: 40, fontSize: 15}}
                            onChange={(e) => {
                                const copy = JSON.parse(JSON.stringify(tempUser));
                                copy.userName = e.target.value;
                                setTempUser(copy);
                            }}
                            value={tempUser.userName}
                            onBlur={onBlur}
                            isInvalid={!!errorState.userName}
                            limitedSpace={false}
                            errorMsg={errorState.userName}
                        />
                    </div>

                    {(!user || !Object.keys(user).length) &&
                        <div className={classes.column} style={{gap: 5}}>
                            <span className={classes.label}>Password</span>
                            <YuJaTextBox
                                id="input-pwd"
                                name={"password"}
                                type={pwdShown ? "text" : "password"}
                                containerStyle={{height: 40, fontSize: 15}}
                                value={tempUser.password}
                                after={
                                    <>
                                        {!!tempUser.password && (
                                            <img
                                                onClick={togglePwd}
                                                src={pwdShown ? EyeOpen : EyeClosed}
                                                alt="eye"
                                                style={{cursor: "pointer"}}
                                            />
                                        )}
                                    </>
                                }
                                onChange={(e) => {
                                    const copy = JSON.parse(JSON.stringify(tempUser));
                                    copy.password = e.target.value;
                                    setTempUser(copy);
                                }}
                                onBlur={onBlur}
                                isInvalid={!!errorState.password}
                                limitedSpace={false}
                                errorMsg={errorState.password}
                            />
                        </div>
                    }

                    {(!user || !Object.keys(user).length) &&
                        <div className={classes.column} style={{gap: 5}}>
                            <span className={classes.label}>Password Confirm</span>
                            <YuJaTextBox
                                id="input-pwd-confirm"
                                name={"passwordConfirm"}
                                type={pwdConfirmShown ? "text" : "password"}
                                containerStyle={{height: 40, fontSize: 15}}
                                value={tempUser.passwordConfirm}
                                after={
                                    <>
                                        {!!tempUser.passwordConfirm && (
                                            <img
                                                onClick={togglePwdConfirm}
                                                src={pwdConfirmShown ? EyeOpen : EyeClosed}
                                                alt="eye"
                                                style={{cursor: "pointer"}}
                                            />
                                        )}
                                    </>
                                }
                                onChange={(e) => {
                                    const copy = JSON.parse(JSON.stringify(tempUser));
                                    copy.passwordConfirm = e.target.value;
                                    setTempUser(copy);
                                }}
                                onBlur={onBlur}
                                isInvalid={!!errorState.passwordConfirm}
                                limitedSpace={false}
                                errorMsg={errorState.passwordConfirm}
                            />
                        </div>
                    }

                    <div className={classes.column} style={{gap: 5}}>
                        <span className={classes.label}>First Name</span>
                        <YuJaTextBox
                            name={"firstName"}
                            containerStyle={{height: 40, fontSize: 15}}
                            value={tempUser.firstName}
                            onChange={(e) => {
                                const copy = JSON.parse(JSON.stringify(tempUser));
                                copy.firstName = e.target.value;
                                setTempUser(copy);
                            }}
                            onBlur={onBlur}
                            isInvalid={!!errorState.firstName}
                            limitedSpace={false}
                            errorMsg={errorState.firstName}
                        />
                    </div>

                    <div className={classes.column} style={{gap: 5}}>
                        <span className={classes.label}>Last Name</span>
                        <YuJaTextBox
                            name={"lastName"}
                            containerStyle={{height: 40, fontSize: 15}}
                            value={tempUser.lastName}
                            onChange={(e) => {
                                const copy = JSON.parse(JSON.stringify(tempUser));
                                copy.lastName = e.target.value;
                                setTempUser(copy);
                            }}
                            onBlur={onBlur}
                            isInvalid={!!errorState.lastName}
                            limitedSpace={false}
                            errorMsg={errorState.lastName}
                        />
                    </div>

                    <div className={classes.column} style={{gap: 5}}>
                        <span className={classes.label}>Email</span>
                        <YuJaTextBox
                            name={"email"}
                            value={tempUser.email}
                            containerStyle={{height: 40, fontSize: 15}}
                            onChange={(e) => {
                                const copy = JSON.parse(JSON.stringify(tempUser));
                                copy.email = e.target.value;
                                setTempUser(copy);
                            }}
                            onBlur={onBlur}
                            isInvalid={!!errorState.email}
                            limitedSpace={false}
                            errorMsg={errorState.email}
                        />
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <div style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: 10
                    }}>
                        <span style={{
                            display: "flex",
                            width: "100%",
                            alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                            <YuJaButton
                                onClick={handleClose}
                                type={"secondary"}
                                style={{width: 80, height: 36, display: "flex", alignItems: "center", justifyContent: "center"}}
                            >
                               {MODAL_CANCEL_TEXT}
                            </YuJaButton>

                            <YuJaButton
                                onClick={handleSave}
                                disabled={isSaveBtnDisabled()}
                                style={{width: 80, height: 36, display: "flex", alignItems: "center", justifyContent: "center", whiteSpace: "nowrap"}}
                            >
                               {MODAL_SAVE_TEXT}
                            </YuJaButton>
                        </span>
                    </div>
                </Modal.Footer>

            </Modal>
        </FocusTrap>
    );
}